
  document.addEventListener("DOMContentLoaded", function () {
  console.log("luxwatches", window.luxwatches)
  // Attach event listener to "Add to Cart" button
  document.querySelectorAll('.add-to-cart-btn').forEach(function(button) {
    button.addEventListener('click', function() {
      var variantId = this.getAttribute('data-variant-id');
      // AJAX request to add product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
       
        // You can update the cart UI here, e.g., showing a confirmation message or updating the cart count
        updateCartCount(); // Optional: function to update the cart count
        window.luxwatches.updateDropdownCart();
        
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
    });
  });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var cartCount = data.item_count;
      document.querySelector('.cstm_cartCount').textContent = cartCount; // Update the cart count display
    })
    .catch(error => console.error('Error updating cart count:', error));
}
 let cart = document.querySelector(".cart-drawer-right");
let cstm_cart=document.querySelector(".cstm_cart_open");
let cstm_addtocart = document.querySelectorAll(".collection_atc");
cstm_addtocart.forEach((item) => {
  item.addEventListener("click", () => {
    setTimeout(()=>{
     if (cart) {
        console.log(cart, "Cart opened");
      cart.classList.add("menu-open"); 
      // cstm_cart.classList.add("cart-show")
       cart.classList.add("menu-openmob"); 
    } else {
      console.log("Cart drawer not found.");
        cart.classList.remove("menu-openmob"); 
    }  
    },1000)
   
  });
});


let cstm_addtocartmob = document.querySelectorAll(".collection_atc");

cstm_addtocartmob.forEach((item) => {
  item.addEventListener("click", () => {
    if (window.innerWidth <= 520) {
      setTimeout(() => {
        if (cart) {
          cstm_cart.classList.add("cart-show");
        } else {
          console.log("Cart not found.");
        }
      }, 1000);
    }
  });
});

document.addEventListener('DOMContentLoaded', (event) => {
       let totalval=document.querySelector(".custm_total").innerHTML;
let formattedTotal = parseInt(totalval.replace(/[^\d]/g, ''), 10);
if(formattedTotal>=5000){
   document.querySelector(".discount_txt")?.classList.add("cstm_txt_cart"); // Removed "." before class name
     }else{
   document.querySelector(".discount_txt")?.classList.remove("cstm_txt_cart"); // Removed "." before class name 
}
        });   

